function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.organizationSharePlacementId = exports.ShowFootprintMessageModal = exports.FootprintStepFilters = exports.FootprintMessageModalEventKey = exports.FootprintMessageModalContainer = exports.ChangeType = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _reactNativeEventListeners = require("react-native-event-listeners");
var _utils = require("../../utils");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _FullScreenDialog = require("../FullScreenDialog");
var _styles = require("./styles");
var _reactNative = require("react-native-web");
var _ShareOrganizationLink = require("../ShareOrganizationLink");
var _models = require("../../models");
var _reactQuery = require("react-query");
var _Heading = require("../Heading");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var FootprintStepFilters = exports.FootprintStepFilters = {
  electricity: 'save_energy',
  gas: 'save_energy',
  oil: 'save_energy',
  waste: 'recycling,cut_back_on_plastic',
  wood: 'save_energy',
  diet: 'eat_sustainably,reduce_waste',
  'food-waste': 'eat_sustainably,reduce_waste',
  aviation: 'green_travel',
  bus: 'green_travel',
  car: 'green_travel',
  metro: 'green_travel',
  motorbike: 'green_travel',
  rail: 'green_travel',
  ship: 'green_travel',
  cruise: 'green_travel',
  taxi: 'green_travel',
  appliances: 'buy_responsibly,reuse',
  cleaning: 'buy_responsibly,reuse,cut_back_on_plastic',
  clothing: 'buy_responsibly,reuse',
  electricals: 'buy_responsibly,reuse',
  furniture: 'buy_responsibly,reuse',
  'personal-care': 'buy_responsibly,cut_back_on_plastic',
  accommodation: 'green_travel',
  'financial-services': 'greener_finance',
  'forest-conservation': 'protect_nature,community_action',
  'tree-planting': 'protect_nature,community_action'
};
var ChangeType = exports.ChangeType = function (ChangeType) {
  ChangeType["negative"] = "negative";
  ChangeType["neutral"] = "neutral";
  ChangeType["positive"] = "positive";
  return ChangeType;
}({});
var FootprintMessageModalEventKey = exports.FootprintMessageModalEventKey = 'showFootprintMessageModalKey';
var ShowFootprintMessageModal = exports.ShowFootprintMessageModal = function ShowFootprintMessageModal(state) {
  _reactNativeEventListeners.EventRegister.emit(FootprintMessageModalEventKey, state);
};
var organizationSharePlacementId = exports.organizationSharePlacementId = 'share-organization-footprint-modal';
var queryKey = ['data', 'user', 'footprintModal'];
var roundPositively = function roundPositively(value) {
  var newValue = Math.round(value);
  if (newValue > 0) {
    newValue = Math.ceil(value);
  } else {
    newValue = Math.floor(value);
  }
  return newValue;
};
var FootprintMessageModalContainer = exports.FootprintMessageModalContainer = (0, _react.memo)(function () {
  var _user$person3, _user$person4, _user$person6;
  (0, _useLang.useLang)();
  var _initialState = (0, _react.useMemo)(function () {
    return {
      kgCo2eChange: 0,
      regionName: undefined,
      existing: false,
      household: false,
      isHidden: true,
      isLoading: false,
      footprintParam: undefined,
      isApp: false
    };
  }, []);
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles;
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(_initialState),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _state = _useState2[0],
    _setState = _useState2[1];
  var _useContext = (0, _react.useContext)(_utils.LinkContext),
    stepsPageLinkUrl = _useContext.stepsPageLinkUrl;
  var navigationContext = (0, _utils.useNavigationContext)();
  var doOnce = (0, _react.useRef)(false);
  var queryClient = (0, _reactQuery.useQueryClient)();
  var _getUser = function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$User$includes$, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _models.User.includes({
              person: ['campaigns', 'organizations', 'peopleAnnouncements']
            }).where({
              'person.peopleAnnouncements.placementId': organizationSharePlacementId
            }).select({
              users: [''],
              people: [''],
              organizations: ['shareUrl'],
              campaigns: ['organizationId'],
              peopleAnnouncements: ['placementId']
            }).find('current');
          case 2:
            _yield$User$includes$ = _context.sent;
            data = _yield$User$includes$.data;
            return _context.abrupt("return", data);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _getUser() {
      return _ref.apply(this, arguments);
    };
  }();
  var changeType = (0, _react.useMemo)(function () {
    if (_state.kgCo2eChange > 0) {
      return ChangeType.positive;
    }
    if (_state.kgCo2eChange < 0) {
      return ChangeType.negative;
    }
    return ChangeType.neutral;
  }, [_state]);
  var _useQuery = (0, _reactQuery.useQuery)(queryKey, _getUser, {
      enabled: !_state.isHidden && !_state.isLoading && changeType === ChangeType.negative
    }),
    user = _useQuery.data,
    isLoadingUser = _useQuery.isLoading;
  var _isLoading = _state.isLoading || isLoadingUser;
  var _text = (0, _jsxRuntime.jsx)(_reactI18next.Trans, {
    i18nKey: "footprintMessageModal:text.".concat(_state.household ? 'household' : 'personal', ".").concat(_state.existing ? 'existing' : 'new', ".").concat(changeType),
    values: {
      amount: Math.abs(roundPositively(_state.kgCo2eChange)),
      regionName: _state.regionName || t('footprintMessageModal:globalDefaultName')
    },
    components: {
      strong: (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.highlight
      })
    }
  });
  var shareUrl = (0, _react.useMemo)(function () {
    var _user$person, _user$person2;
    return (0, _utils.getShareUrl)(user == null ? void 0 : (_user$person = user.person) == null ? void 0 : _user$person.organizations, user == null ? void 0 : (_user$person2 = user.person) == null ? void 0 : _user$person2.campaigns);
  }, [user == null ? void 0 : (_user$person3 = user.person) == null ? void 0 : _user$person3.campaigns, user == null ? void 0 : (_user$person4 = user.person) == null ? void 0 : _user$person4.organizations]);
  var _showShare = (0, _react.useMemo)(function () {
    var _user$person5, _user$person5$peopleA, _user$person5$peopleA2;
    return !_state.isHidden && changeType === ChangeType.negative && !!shareUrl && !(user != null && (_user$person5 = user.person) != null && (_user$person5$peopleA = _user$person5.peopleAnnouncements) != null && (_user$person5$peopleA2 = _user$person5$peopleA[0]) != null && _user$person5$peopleA2.id);
  }, [_state.isHidden, changeType, shareUrl, user == null ? void 0 : (_user$person6 = user.person) == null ? void 0 : _user$person6.peopleAnnouncements]);
  var _showShareOnce = (0, _react.useCallback)((0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var peopleAnnouncement;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(doOnce.current || !_showShare)) {
            _context2.next = 2;
            break;
          }
          return _context2.abrupt("return");
        case 2:
          doOnce.current = true;
          peopleAnnouncement = new _models.PeopleAnnouncement({
            personId: user == null ? void 0 : user.person.id,
            placementId: organizationSharePlacementId
          });
          _context2.next = 6;
          return peopleAnnouncement.save();
        case 6:
          queryClient.invalidateQueries(queryKey);
        case 7:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [_showShare, queryClient, user == null ? void 0 : user.person.id]);
  var _closeModal = function _closeModal() {
    var _window, _window$location;
    if (_state.isApp && _reactNative.Platform.OS === 'web' && (_window = window) != null && (_window$location = _window.location) != null && _window$location.href) {
      window.location.href = "giki.zero://footprints";
      return;
    }
    _setState(function (prevState) {
      return Object.assign({}, prevState, {
        isHidden: true
      });
    });
    void _showShareOnce();
  };
  var _stepsPageLinkOnPress = function _stepsPageLinkOnPress() {
    _closeModal();
    if (stepsPageLinkUrl) {
      var _window2, _window2$location;
      var _filter = _state.footprintParam && FootprintStepFilters[_state.footprintParam] ? "?filter=".concat(FootprintStepFilters[_state.footprintParam]) : '';
      if (_state.isApp && _reactNative.Platform.OS === 'web' && (_window2 = window) != null && (_window2$location = _window2.location) != null && _window2$location.href) {
        window.location.href = "giki.zero://actions".concat(_filter);
        return;
      }
      navigationContext.navigate("".concat(stepsPageLinkUrl).concat(_filter));
    }
  };
  (0, _react.useEffect)(function () {
    var _listener = _reactNativeEventListeners.EventRegister.addEventListener(FootprintMessageModalEventKey, function (newState) {
      _setState(function (prevState) {
        return Object.assign({}, prevState, {
          isHidden: false,
          isLoading: false,
          isApp: false
        }, newState);
      });
    });
    return function () {
      _reactNativeEventListeners.EventRegister.removeEventListener(_listener);
    };
  }, []);
  return (0, _jsxRuntime.jsxs)(_FullScreenDialog.FullScreenDialog, {
    isHidden: _state.isHidden,
    closeCallback: _closeModal,
    isLoading: _isLoading,
    cardStyle: styles.modalCardStyle,
    primaryActionLabel: t("footprintMessageModal:buttonLabel.".concat(changeType)),
    primaryActionCallback: _stepsPageLinkOnPress,
    children: [(0, _jsxRuntime.jsx)(_Heading.Heading, {
      style: styles.title,
      level: 2,
      children: t("footprintMessageModal:title.".concat(changeType))
    }), (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.text,
      children: _text
    }), _showShare && (0, _jsxRuntime.jsx)(_ShareOrganizationLink.ShareOrganizationLink, {
      style: styles.share,
      shareUrl: shareUrl,
      children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
        style: styles.text,
        children: t("footprintMessageModal:organizationShare")
      })
    })]
  });
});